import type { ThemeOptions } from '@mui/material';
import { white, green, gray, black } from '~/styles/colors';

const SwitchTheme: ThemeOptions['components'] = {
  MuiSwitch: {
    styleOverrides: {
      switchBase: {
        color: white,
        '&.Mui-checked': {
          color: green[900],
          '& .MuiSwitch-thumb': {
            border: 'none',
          },
        },
        '&.Mui-checked + .MuiSwitch-track': {
          backgroundColor: `${green[300]} !important`,
        },
        '&.Mui-disabled': {
          color: white,
          '& .MuiSwitch-thumb': {
            border: `1px solid ${gray[400]}`,
            boxShadow: 'none',
            '&.Mui-checked': {
              border: `1px solid ${black[100]}`,
            },
          },
          '& + .MuiSwitch-track': {
            backgroundColor: white,
            border: `1px solid ${gray[300]}`,
            opacity: 1,
          },
          '&.Mui-checked': {
            color: gray[400],
          },
          '&.Mui-checked + .MuiSwitch-track': {
            backgroundColor: `${black[100]} !important`,
          },
        },
      },
      thumb: {
        border: `1px solid ${gray[400]}`,
      },
      track: {
        backgroundColor: black[300],
        opacity: 1,
      },
    },
  },
};

export default SwitchTheme;
